/**
 * Helper para determinar si las puertas de un grupo están abiertas
 * Sistema unificado para membresías y experiencias
 */

export interface Group {
  subscriptions_status?: 'open' | 'closed';
  subscriptions_opening_date?: string | null;
  subscriptions_closing_date?: string | null;
  status?: string; // Campo de estado general del grupo
  registration_closing_date?: string | null; // deprecated
}

/**
 * Determina si las puertas de inscripción están abiertas
 * @param group - Objeto del grupo (membership, experience, etc)
 * @returns true si las puertas están abiertas, false si están cerradas
 */
export const areDoorsOpen = (group: Group | null | undefined): boolean => {
  if (!group) return false;

  // Sistema unificado: usar subscriptions_status
  // 'open' = puertas abiertas
  // 'closed' = puertas cerradas
  return group.subscriptions_status === 'open';
};

/**
 * Determina si las puertas están cerradas o las inscripciones han expirado
 * @param group - Objeto del grupo
 * @returns true si las puertas están cerradas
 */
export const areDoorsClosedOrExpired = (group: Group | null | undefined): boolean => {
  return !areDoorsOpen(group);
};

/**
 * Obtiene información sobre el cierre programado de puertas
 * @param group - Objeto del grupo
 * @returns Información sobre si hay cierre programado y la fecha
 */
export const getClosingInfo = (group: Group | null | undefined) => {
  if (!group) {
    return {
      hasProgrammedClosing: false,
      closingDate: null
    };
  }

  // Si tiene subscriptions_closing_date programada en el futuro
  if (group.subscriptions_closing_date && new Date(group.subscriptions_closing_date) > new Date()) {
    return {
      hasProgrammedClosing: true,
      closingDate: group.subscriptions_closing_date
    };
  }

  return {
    hasProgrammedClosing: false,
    closingDate: null
  };
};

/**
 * Obtiene información sobre la apertura programada de puertas
 * @param group - Objeto del grupo
 * @returns Información sobre si hay apertura programada y la fecha
 */
export const getOpeningInfo = (group: Group | null | undefined) => {
  if (!group) {
    return {
      hasProgrammedOpening: false,
      openingDate: null
    };
  }

  // Si tiene subscriptions_opening_date programada en el futuro
  if (group.subscriptions_opening_date && new Date(group.subscriptions_opening_date) > new Date()) {
    return {
      hasProgrammedOpening: true,
      openingDate: group.subscriptions_opening_date
    };
  }

  return {
    hasProgrammedOpening: false,
    openingDate: null
  };
};

